import http, { fetchApi } from "@/utils/axios";
import URL from "@/api/urlConfig"

const prefix = '/api/dscloud-app-forum'

const local = '/local'

// 获取所有项目
export const getProjects = () => {
    return fetchApi(URL.BINDING_PROJECT_LIST, null)
}

// 添加修改签到规则
export const signRule = (data) => {
    return fetchApi(URL.SIGN_RULE, data, 'POST', 'data')
}
// 获取所有人群
export const findAllCrowd = () => {
    return fetchApi(URL.GET_ALL_CROWD, 'null', 'get');
}

// 获取活动列表
export const getActivityList = (size, page, data) => {
    const params = {
        title: data.activityTitle,
        activityMode: data.activityWay,
        status:data.activityStatus,
        activityStartTime:data.activityStart,
        activityEndTime: data.activityEnd,
        projectIds: data.projectIds,
        paging: {
            page: page-1,
            size: size
        }
    }
    return fetchApi(URL.GET_ACTIVITY_LIST, params, 'POST', 'data', true)
}

// 禁用启用活动
export const toStartUsingAndEnable = (id, status) => {
    const data = {
        id: id,
        activityState: status
    }
    return fetchApi(URL.START_USING_AND_ENABLE_ACTIVITY, data, 'post', 'params')
}

// 删除活动
export const removeActivityById = (id) => {
    const data = {
        id: id
    }
    return fetchApi(URL.REMOVE_ACTIVITY_BY_ID, data, 'post', 'params')
}
// 新建活动
export const addActivity = (data) => {
    return fetchApi(prefix + '/web/activityInformation/insert', data, 'post', 'data')
}
// 修改活动
export const updateActivity = (data) => {
    return fetchApi(prefix + '/web/activityInformation/updateById', data, 'post', 'data')
}

// 根据id获取活动详情
export const findActivityById = (id) => {
    const data = {
        id: id
    }
    return fetchApi(prefix + '/web/activityInformation/findById', data, 'post', 'params')
}

// 查询积分规则信息
export const findPointsRuleInfo = ruleNo => fetchApi(URL.FIND_POINTS_RULE_INFO, { ruleNo });

/**
* @description 导出签署电子协议文件
* @author cxd
* @time 2025-06-22 17:07:06
*/
export const exportSignAgreementFile = (data) => {
    return http({
        url: prefix + '/web/activityInformation/export-protocol-sign-file',
        method: "post",
        data,
        responseType: 'blob',
        headers: {
            "Content-Type": "application/json",
        }
    })
}

/**
 * 查询圈子ID列表
 */
export const fetchCircleList = () => {
    return fetchApi(prefix + '/web/activityInformation/circle-list', null, 'post', 'data');
}

/**
 * @Description：查询活动报名用户列表
 * @Author cxd
 * @Date 2026/1/6 18:53
 */
export const getAppliedUserInfoByActivityIdAndPhoneNumber = (activityId, mobile) => {
    const data = {
        activityId,
        mobile
    }
    return fetchApi(prefix + '/web/activityInformation/user/list', data, 'POST', 'data');
}


/**
 * @Description：取消用户报名
 * @Author cxd
 * @Date 2026/1/6 19:21
 */
export const cancelApply = (data) => {
    return fetchApi(prefix + '/web/activityInformation/user/cancle/insert', data, 'post', 'data');
}

/**
 * @Description：获取黑名单管理列表
 * @Author cxd
 * @Date 2026/1/12 14:13
 */
export const selectBlackList = (data) => {
    return fetchApi(prefix + '/web/activityInformation/user/black/list', data, 'post', 'data')
}

/**
 * @Description：下载模版
 * @Author cxd
 * @Date 2026/1/12 14:28
 */
export const downloadTemplate = () => {
    return http({
        url: prefix + '/web/activityInformation/user/black/download',
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        method: 'get'
    })
}

/**
 * @Description：根据手机号获取用户信息
 * @Author cxd
 * @Date 2026/1/12 14:50
 */
export const selectUserInfoByMobile = (mobile) => {
    const params = {
        mobile
    }
    return fetchApi(prefix + '/web/activityInformation/user/selectActivityUserByMobile', params, 'get', 'params')
}

/**
 * @Description：添加黑名单
 * @Author cxd
 * @Date 2026/1/12 15:00
 */
export const insertBlackList = (data) => {
    return fetchApi(prefix + '/web/activityInformation/user/black/insert', data, 'post', 'data')
}
/**
 * @Description：修改黑名单
 * @Author cxd
 * @Date 2026/1/12 17:51
 */
export const editBlackList = (data) => {
    return fetchApi(prefix + '/web/activityInformation/user/black/update', data, 'post', 'data')
}
/**
 * @Description：移除黑名单
 * @Author cxd
 * @Date 2026/1/12 15:45
 */
export const removeBlackListById = (data) => {
    return fetchApi(prefix + '/web/activityInformation/user/black/remove', data, 'post', 'data')
}

/**
 * @Description：导出黑名单管理
 * @Author cxd
 * @Date 2026/1/12 15:51
 */
export const exportBlackList = (data) => {
    return  http({
        url: prefix + '/web/activityInformation/user/black/export',
        method: "post",
        data,
        responseType: 'blob',
        headers: {
            "Content-Type": "application/json",
        }
    })
}

/**
 * @Description：根据黑名单id查询详情
 * @Author cxd
 * @Date 2026/1/14 10:09
 */
export const getBlackListDetailsById = (id) => {
    const params = { id }
    return fetchApi(prefix + '/web/activityInformation/user/black/selectByPrimaryKey', params, 'get', 'params')
}

/**
 * @Description: 调整报名人数
 * @Author: cxd
 * @Date: 2026/3/24 15:19
 */
export const adjustActivityNumber = (data) => {
    return fetchApi(prefix + '/web/activityInformation/set-registration-base-person-size', data, 'post', 'data')
}

/**
 * @Description: 获取调整报名的限制
 * @Author: cxd
 * @Date: 2026/3/25 9:37
 */
export const  getActivityNumberLimit = (params) => {
    return fetchApi(prefix + '/web/activityInformation/get-registration-count', params)
}

/**
 * @description：查询可关联的问卷
 * @author：cxd
 * @time：2026/4/10 14:12
 **/
export const selectQuestionnaireList = () => {
    return fetchApi(prefix + '/web/survey/questionnaire/ongoing')
}


/**
 * @description：获取当前活动的报名列表
 * @author：cxd
 * @time：2026/4/8 10:42
 **/
export const getUserRegistrationList = (params) => {
  return fetchApi(prefix + '/web/activityInformation/user/list', params, 'post', 'data')
}

/**
 * @description：分页查询活动报名用户（管理端）
 * @param {Object} data
 * @param {string} [data.activityId] 活动 id
 * @param {string} [data.userId] 报名用户 id
 * @param {string} [data.mobile] 报名用户手机号
 * @param {string} [data.auditStatus] 审核状态 10 待审核 / 20 已通过 / 30 已驳回
 * @param {string} [data.registrationState] 报名状态 0 报名成功 / 1 已取消
 * @param {string} [data.writeOffType] 核销状态 0 未核销 1 已核销
 * @param {string} [data.beginTime] 报名开始时间
 * @param {string} [data.endTime] 报名结束时间
 * @param {number} data.pageNum 页码（必填）
 * @param {number} data.pageSize 每页条数（必填）
 **/
export const searchActivityUserRegistration = (data) => {
  return fetchApi(prefix + '/web/activityInformation/user/search', data, 'post', 'data')
}

/**
 * @description：活动报名用户详情（GET，query：id 报名记录 ID）
 **/
export const getActivityUserRegistrationDetail = (params) => {
  return fetchApi(prefix + '/web/activityInformation/user/detail', params, 'get', 'params')
}

/**
 * @description：审核活动报名记录
 * @param {Object} data
 * @param {string} data.signUpId 报名记录 ID
 * @param {string} data.auditResult 审核结果：20 已通过，30 已驳回
 * @param {string} data.isSendNotice 是否发送通知：10 发送，20 不发送（必填；审核通过时可传 20）
 * @param {string} [data.auditRejectReason] 审核驳回原因（auditResult=30 且需通知用户时必填）
 **/
export const auditActivityUserRegistration = (data) => {
  return fetchApi(prefix + '/web/activityInformation/user/audit', data, 'post', 'data')
}

/**
 * @description：批量审核活动报名记录
 * @param {Object} data
 * @param {string[]} data.signUpIdList 报名记录 ID 列表
 * @param {number} data.auditResult 审核结果：20 已通过，30 已驳回
 * @param {string} data.isSendNotice 是否发送通知：10 发送，20 不发送（必填；审核通过时可传 20）
 * @param {string} [data.auditRejectReason] 审核驳回原因（auditResult=30 且需通知用户时必填）
 **/
export const batchAuditActivityUserRegistration = (data) => {
  return fetchApi(prefix + '/web/activityInformation/user/batchAudit', data, 'post', 'data')
}

/**
 * @description：查询活动分类
 * @author：cxd
 * @time：2026/4/14 14:28
 **/
export const selectActivityType = () => {
    return fetchApi(prefix + '/web/activityInformation/list-activity-classify')
}

/**
 * @description：下载白名单模版
 * @author：cxd
 * @time：2026/4/14 16:44
 **/
export const downloadWhiteListTemplate = () => {
    return fetchApi(prefix + '/web/activityInformation/get-register-user-white-template')
}

/**
 * @description：查询用户标签
 * @author：cxd
 * @time：2026/4/14 17:53
 **/
export const selectUserTag = () => {
    return fetchApi(prefix + '/web/activityInformation/list-yuejie-user-label')
}

/**
 * @description：校验商品是否可绑定
 * @author：cxd
 * @time：2026/4/16
 **/
export const checkProductBinding = (data) => {
    return fetchApi(prefix + '/web/activityInformation/check-product-binding', data, 'post', 'data')
}
